import React, { useState } from "react"
import { Slider } from "@mui/material"

interface Props {
  rate: number
  setRate: React.Dispatch<React.SetStateAction<number>>
}

const MuiSlider = (props: Props) => {
  const { rate, setRate } = props

  const handleChange = (event: Event, newValue: number | number[]) => {
    setRate(newValue as number)
  }

  return (
    <div style={{ width: "276px", margin: "0 auto", textAlign: "center" }}>
      <Slider
        value={rate}
        onChange={handleChange}
        min={50}
        max={100}
        valueLabelDisplay="auto"
        sx={{
          "& .MuiSlider-thumb": {
            backgroundColor: "#3957D3",
          },
          "& .MuiSlider-track": {
            backgroundColor: "#3957D3",
          },
        }}
      />
    </div>
  )
}

export default MuiSlider
